<template>
  <div id="SelfdefiningControl" class="selfdefiningControl h100pct bgWhite">
    <div class="pl1x pr1x pt1x scrollY h80pct bdSub-bottom" id='xxx' fillheight="lastHeight*0.8" scroll>
      <div class='clickMore curP fMain'>
        <Icon name="time" class="w1x h1x " :sizeBase="'m'"></Icon><span v-debounce:click='toOrder' class='pr1x curP cMain' style="padding-top: 2px;">&nbsp;&nbsp;{{getLanguageStr('message1', '查看更多消息')}}</span>
      </div>
      <div class="chat-content ">

        <div v-for="(item,index) in showList">
          <div class="pb1x pr10x pl1x pt1x" v-if="item.type == 'answer'">
            <div class="dpIB-imp dpIB s-answer">
              <section class="taR"><span class="dpIB pt05x pr05x pb05x pl05x bgLight boxR-light">{{timeFormat(item.time / 1000,'inc','%Y/%m/%d %H:%M:%S UTC')}}</span></section>
              <section class="content mt05x mb05x posR">
                <span class="dpIB pt1x pr1x pb1x pl1x bgLight boxR-light">{{item.command}}</span>
              </section>
            </div>
          </div>
          <div class="pb1x pr1x pl10x taR tableSys" v-if="item.type == 'send'">
            <div class="w8x dpIB-imp dpIB fr taC"><span v-if="item.status==500&&!issendNow" @click="reSendControl(item)" class="blue dpIB pdb1x curP">{{getLanguageStr('cmd57','再次发送')}}</span></div>
            <div class="dpIB-imp dpIB fr">
              <section class="taL"><span class="dpIB pt05x pr05x pb05x pl05x bgLight boxR-light">{{timeFormat(item.time / 1000,'inc','%Y/%m/%d %H:%M:%S UTC')}}</span></section>
              <section class="content mt05x mb05x posR">
                <span class="dpIB pt1x pr1x pb1x pl1x lh12 bgBlue boxR-light taL">{{item.ack?item.ack:item.command}}</span>
              </section>
              <section class="status"><span v-if="item.status==500" class='cError'>{{getLanguageStr('task66','指令发送失败')}}</span><span v-if="item.status==666">{{getLanguageStr('device255','指令发送成功')}}</span><span v-if="item.status==100">{{getLanguageStr('word1542','发送中')}}...</span></section>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="h20pct pl1x pr1x pb1x pt1x borderbox">
      <textarea class="textarea w100pct h50pct"
                :placeholder="getLanguageStr('manage244','请输入命令内容')"
                v-model="sendContent"
                maxLength="255"></textarea>
      <div class="tableSys vaM_E">
        <div class="pt1x taR fR vaM_EE">
          <!--<button v-if="showList.length" @click="clear" class="functionBtn bdSub fR tra-fast mr05x" type="button">{{$t("cmd6",["清空"])}}</button>-->
          <button v-if="sendContent" @click="sendContent=''" class="cSub bdSub boxR pl1x pr1x mr1x sizeM" type="button">{{$t("cmd6",["清空"])}}</button>
          <div class="dpIB pr1x" v-if="device.productId === '0_D0002_18'">
            <span class="cSub pr1x">{{getLanguageStr('control42','指令对象')}}:</span>
            <Select :list="listObject" :class="{'active':activeObj,'sizeS':true}" style="dpB" :keyMap="{text:'name',value:'value'}" :bindActive="activeObj" v-model='activeObj' @Click='selectP' />
          </div>
          <div class="dpIB pr2x">
            <span class="cSub">{{getLanguageStr('word1507','超时时间')}}：</span>
            <input-text class="w3x dpIB ml05x mr05x" v-model="orderTimeouts" :max-length="2" only="absInt" :verification="'notEmpty,~:1~40'"></input-text>
            <span class="cSub">{{getLanguageStr('unit54','分钟')}}</span>

          </div>
          <button :class="{'disable':sendSeconds>0}" class="functionBtn" type="button" onclick="statistic('A69','A6902')" @click="controlSend">{{$t("cmd74",["发送"])}}<span v-show="sendSeconds">({{sendSeconds}}s)</span></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as lib from '@/util/lib';
import {getLanguageStr} from '@/util/language';
import Select from '@/components/common/ui/Select.vue';
import {orderActionControlSend, orderActionLast, orderActionById, apiGetCustomTimeoutList} from '@/api/device/order';
import InputText from '@/components/common/ui/InputText.vue';
import Help from '@/components/common/Help.vue';
export default {
	name: 'SelfdefiningControl',
	components: {InputText, Help, Select},
	props: {
		device: {
			type: Object
		},
		deviceType: {
			type: [Number, String],
			default: 2
		},
		orderTimeout: {// 指令超时时间 单位秒
			type: Number,
			default: 20
		}
	},
	data () {
		return {
			issendNow: false,
			hasclick: false,
			sendContent: '',
			orderTimeouts: 10,
			isSending: false, // 是否正在发送请求
			showList: [], // 展示当前发送跟返回的指令信息
			curQueryList: [], // 当前需要查询的指令list
			pollingInterval: false, // 轮询接口去读取返回结果 定时器
			btnInterval: null,
			sendSeconds: null, // 倒计时读秒
			status: 100, // 发送状态：1：发送中， 2：成功 3：失败
			listObject: this.getTypeText('', 'instructionsobject', true),
			activeObj: null
		};
	},
	watch: {
		showList (v) {
			let c = v.filter(item => {
				if (item.status == 100) {
					return item;
				}
			});
			c.length === 0 && (this.issendNow = false);
		},
		'device.productId': function (v) {
			if (v == '0_D0002_18') {
				this.activeObj = this.getTypeText('', 'instructionsobject', true)[0].value;
			} else {
				this.activeObj = null;
			}
		}
	},
	methods: {
		timeFormat: lib.timeFormat,
		getTypeText: lib.getTypeText,
		getLanguageStr,
		selectP () {

		},
		clear () {
			// 清空定时器
			if (this.btnInterval) { clearInterval(this.btnInterval); this.btnInterval = null; }
			if (this.pollingInterval) { clearInterval(this.pollingInterval); this.pollingInterval = false; }
			// 清空指令列表
			this.showList = [];
			this.curQueryList = [];
			// 清空输入内容
			this.sendContent = '';
			this.sendSeconds = 0;
		},
		reSendControl (item) { // 再次发送
			this.send(item.command);
		},
		controlSend () { // 发送指令
			if (this.orderTimeouts > 40 || this.orderTimeouts < 1) {
				return;
			}
			if (this.sendContent.replace(/\s*/g, '') == '') {
				this.$notify(getLanguageStr('device244', '指令不能为空'));
			} else {
				this.send(this.sendContent);
				this.btnSeconds(10);// 按钮10秒倒计时
			}
		},
		btnSeconds (t) {
			if (this.sendSeconds) return;
			let _ths = this;
			this.sendSeconds = t;
			this.btnInterval = setInterval(function () {
				_ths.sendSeconds -= 1;
				if (_ths.sendSeconds == 0) {
					clearInterval(_ths.btnInterval);
					_ths.sendSeconds = null;
				}
			}, 1000);
		},
		showListAdd (cl) { // 发送指令
			this.showList.unshift(cl);
			this.curQueryList.push(cl);
			// 判断是否再轮询查询，
			if (this.pollingInterval) { // 已经再轮询了，不处理直接返回
				return false;
			} else { // 还没有轮询，开始轮询
				let _this = this;
				this.pollingInterval = setInterval(() => {
					this.polling();
				}, 5000);
			}
		},
		changeShowList (item) {
			let f = true;// 找最新未处理的
			this.showList = this.showList.map((sItem, index) => {
				if (f && sItem.type == 'send' && sItem.status == 100 && sItem.command == item.command) {
					sItem.status = item.status;
					f = false;
				}
				return sItem;
			});
			if (item.status == 666) { // 成功返回，showList 显示
				this.showList.unshift({
					command: item.ack,
					time: item.time,
					status: item.status,
					type: 'answer'
				});
			}
			$(this.$el).find('#xxx').mCustomScrollbar('scrollTo', 'bottom');
		},
		polling () { // 轮询查询状态
			this.curQueryList = this.curQueryList.filter(item => { return item.status <= 300; });
			if (this.curQueryList.length == 0) { clearInterval(this.pollingInterval); this.pollingInterval = false; }
			this.curQueryList = this.curQueryList.map((item, index) => {
				if (item.status <= 300) {
					this.pollingQuery(item).then(res => {
						if (res) {
							let {status, ack, orderId} = res;
							item = {...item, status, ack, orderId};
							this.curQueryList[index] = item;
							item.time = res.updateTime;
							if (res.status > 300) this.changeShowList(item);// 成功或者失败改变showList 状态
						} else {
							item.status = 100;
							this.changeShowList(item);
						}
					}).catch(error => {
						item.status = 100;
						this.changeShowList(item);
					});
				}
				return item;
			});
		},
		async pollingQuery (item) { // 查询结果
			let result;
			try {
				if (item.orderId) {
					result = await orderActionById(item.orderId);
					return result;
				} else { // 最近指令记录(控制/升级)
					result = await orderActionLast({
						deviceId: this.device.deviceId,
						deviceType: this.deviceType,
						orderType: 1, // 指令类型(1.控制指令 2.升级指令)
						operationType: 3, // 自定义
						language: stage.languageId
					});
					return result;
				}
			} catch (error) {
				!_.isEmpty(error) && this.$notify(error);
				return false;
			}
		},
		async send (cmd) {
			this.issendNow = true;
			if (this.isSending) return;
			this.isSending = true;
			let req = {
				'content': cmd.replace(/\s*/g, ''), // 调用接口去掉空格
				'deviceId': this.device.deviceId,
				'deviceSn': this.device.deviceSn,
				// 'deviceType': this.deviceType, // 1:采集器 2:普通设备
				'gatewayId': this.device.parDeviceId,
				'gatewaySn': this.device.parDeviceSn,
				'operationType': 3, // 自定义
				'orderTimeout': this.orderTimeouts * 60, // 指令超时时间 单位秒
				'product': this.device.productId,
				'x0': this.activeObj
				// 'sensor': this.device.sensor
			};
			try {
				await orderActionControlSend(req);
				// 添加显示队列 跟 轮询队列
				this.showListAdd({
					command: cmd,
					time: new Date().getTime(),
					status: 100,
					type: 'send'
				});
				this.$nextTick(() => {
					$(this.$el).find('#xxx').mCustomScrollbar('scrollTo', 'bottom');
				});
				this.isSending = false;
			} catch (error) {
				!_.isEmpty(error) && this.$notify(error);
				this.isSending = false;
			}
		},
		toOrder () {
			if (this.hasclick) {
				return;
			}
			this.hasclick = true;
			this.$bus.$emit('openViewdetail', this.device, 'OperateRecord', this.deviceType, 1, false, this.$el);
			setTimeout(() => {
				this.hasclick = false;
			}, 5000);
		},
		showLast () {
			orderActionLast({
				deviceId: this.device.deviceId,
				deviceType: this.deviceType,
				orderType: 1, // 指令类型(1.控制指令 2.升级指令)
				operationType: 3, // 自定义
				language: stage.languageId
			}).then(res => {
				if (res) {
					this.showListAdd({
						command: res.content,
						time: res.createTime,
						status: res.status,
						type: 'send'
					});
					if (res.status === 666) {
						this.showList.unshift({
							command: res.ack,
							time: res.updateTime,
							status: res.status,
							type: 'answer'
						});
					}
				}
			});
		}
	},
	mounted () {
		setTimeout(() => {
			lib.fillHeight();
			lib.setScroll($('#SelfdefiningControl [scroll]'));

			let requestObj = {
				module: 100
			};
			// 获取默认超时时间
			if (this.device.deviceId) {
				apiGetCustomTimeoutList(this.device.deviceId, requestObj).then((res) => {
					if (res) {
						this.orderTimeouts = res / 60 || 3;
					}
				});
			}
		}, 500);
	}
};
</script>

<style  lang="scss" scoped>
.borderbox {
  box-sizing: border-box;
}
.chat-content {
  display: flex;
  flex-direction: column-reverse;
  -moz-box-orient: vertical;
  -webkit-box-orient: vertical;
  -webkit-box-direction: reverse;
  -moz-box-direction: reverse;
}
.chat-content .resend {
  vertical-align: middle;
}
.clickMore {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/view/device/device/part/SelfdefiningControl.vue